export const skillList = [
    {
        skillName: 'HTML',
        skillUrl: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/html5-colored.svg',
    },
    {
        skillName: 'CSS',
        skillUrl: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/css3-colored.svg',
    },
    {
        skillName: 'JavaScript',
        skillUrl: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/javascript-colored.svg',
    },
    {
        skillName: 'React',
        skillUrl: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/react-colored.svg',
    },
    

    {
        skillName: 'Git',
        skillUrl: 'https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg'
    },
    {
        skillName: 'Mysql',
        skillUrl: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/mysql-colored.svg'
    },

    {
        skillName: 'C++',
        skillUrl:'https://img.icons8.com/?size=512&id=40669&format=png'
    },


    {
        skillName: 'JAVA',
        skillUrl:'https://img.icons8.com/?size=512&id=13679&format=png'
    },


];
